import React from 'react';
import { useDispatch } from 'react-redux';
import Header from './Header';
import Sidebar from './Sidebar';
import { toggleSidebar } from '../redux/actions/sidebar/uiActions';

const layoutStyle = {
  display: 'flex',
  minHeight: '100vh',
  background: 'var(--luxury-bg)',
};

// const mainStyle = {
//   flex: 1,
//   padding: '2.5rem 3.5rem',
//   background: 'transparent',
//   borderRadius: 'var(--luxury-radius)',
//   boxShadow: 'var(--luxury-shadow)',
//   margin: '2.5rem',
// };
const mainStyle = {
  flex: 1,
  padding: '2rem',
  background: 'transparent',
  marginTop: 72,
  marginLeft: 220,
  minHeight: 'calc(100vh - 72px)',
  transition: 'margin 0.2s',
};

const Layout = ({ children }) => {
  const dispatch = useDispatch();

  const handleMenuClick = () => {
    dispatch(toggleSidebar());
  };

  return (
    <div>
      <Header onMenuClick={handleMenuClick} />
      <div style={layoutStyle}>
        <Sidebar />
        <main style={mainStyle}>{children}</main>
      </div>
    </div>
  );
};

export default Layout; 